export default [
    // signup route with optional refererral link
    {
        path: '/',
        name: 'app.index',
        component: () => import(/* webpackChunkName: "join" */ '@/views/indexView.vue'),
        meta: {
            layout: 'dashboard'
        }
    }
];
